module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/contents/noimage_s90x90-ff7be1788a0ccc44e27028072f2f23de.png";